module.exports = __webpack_public_path__ + "img/arrow-down.85b32b79.svg";